import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Grid, Group, ThemeIcon } from '@mantine/core'
import { getDataStatsPlatform } from '../../../services/dashboard'
import { PieChart } from '@mantine/charts'
import { IconPointFilled } from '@tabler/icons-react'

const DashboardStatsPlatform = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsPlatform, setStatsPlatform] = useState([])

  const getRandomColor = () => {
    const letter = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letter[Math.floor(Math.random() * 16)]
    }
    return color
  }

  const handleGetStatsPlatform = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsPlatform()
      if (response?.data) {
        const responseStats = response.data.integratedPlatformStats
        const remapData = responseStats.map((val) => {
          return {
            ...val,
            value: val.count,
            color: getRandomColor()
          }
        })
        setStatsPlatform(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsPlatform()
    // eslint-disable-next-line
  }, [])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={120}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    const mappingPlatform = (data) => {
      if (data.length > 0) {
        const remap = data.map((val, index) => {
          return (
            <Group gap={2}>
              <ThemeIcon variant="white" size='lg' color={val.color}>
                <IconPointFilled style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Text fz={12} fw='500'>{val.name}</Text>
            </Group>
          )
        })
        return remap
      }
    }

    return (
      <Box>
        <Grid align='flex-start'>
          <Grid.Col span={{ base: 12, md: 5, lg: 5 }}>
            <Box>
              {mappingPlatform(statsPlatform)}
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 7, lg: 7 }}>
            <PieChart
              size={260}
              data={statsPlatform}
              labelPosition='outside'
              labelsType='percent'
              withLabels
              withTooltip tooltipDataSource="segment"
            />
          </Grid.Col>
        </Grid>
      </Box>
    )
  }

  return (
    <Paper shadow="sm" p='md' withBorder radius='md'>
      <Text fz='md' fw='bold' mb='md'>Platforms Integration</Text>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatsPlatform